import { useAtomValue } from 'jotai';
import { RESET, useAtomCallback, useResetAtom } from 'jotai/utils';
import React, { useCallback } from 'react';

import { Button, Modal, Text } from '~/components/blocks';
import {
  eventPageInfoState,
  patientDetailConfirmBreakawayState,
  patientDetailDialogMessageState,
  patientDetailDialogProfileState,
  patientDetailDialogState,
  patientDetailDialogTracingReportState,
} from '~/state/partials/patient_detail_dialog/atoms';
import { TabType } from '~/state/partials/patient_detail_dialog/types';

export const ConfirmBreakawayModal = () => {
  const { isOpen } = useAtomValue(patientDetailConfirmBreakawayState);
  const resetPatientDetailConfirmBreakawayState = useResetAtom(patientDetailConfirmBreakawayState);

  const handleClose = useCallback(
    () => resetPatientDetailConfirmBreakawayState(),
    [resetPatientDetailConfirmBreakawayState],
  );

  const handleConfirm = useAtomCallback(
    useCallback((get, set) => {
      const { action } = get(patientDetailConfirmBreakawayState);
      const { patientId } = get(patientDetailDialogState);

      if (action === 'close') {
        set(patientDetailConfirmBreakawayState, RESET);
        set(patientDetailDialogState, RESET);
        set(patientDetailDialogMessageState, RESET);
        set(patientDetailDialogTracingReportState, RESET);
        set(eventPageInfoState, RESET);
        set(patientDetailDialogProfileState, RESET);
      } else if (action === 'toTracingReport' && patientId) {
        set(patientDetailConfirmBreakawayState, RESET);
        set(patientDetailDialogMessageState, (_state) => ({
          ..._state,
          selectedMessageId: null,
        }));
        set(patientDetailDialogState, (_state) => ({
          ..._state,
          patientId,
          isOpen: true,
          type: 'tracingreport' as TabType,
        }));
      }
    }, []),
  );

  return (
    <Modal open={isOpen} size="s" onClose={handleClose}>
      <Modal.Header>
        <Text size="l">編集内容を破棄しますか？</Text>
      </Modal.Header>
      <Modal.Body>
        <Text size="m">
          このメッセージは自動保存が無効です。
          <br />
          保存前に画面を移動すると変更内容は破棄されます。
        </Text>
      </Modal.Body>
      <Modal.Footer>
        <Button use="secondary" onClick={handleConfirm}>
          破棄
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
